<div class="page">
    <div class="page-header">
        <div class="header-left">
            <mat-icon class="back-icon" routerLink="/specialities">arrow_back</mat-icon>
            <h3>{{ speciality.name | uppercase }} SZAKRENDELÉS MÓDOSÍTÁSA</h3>
        </div>
    </div>
    <p class="required-info">A * - al jelölt mezők kitöltése kötelező!</p>

    <div class="form-section">
        <form novalidate [formGroup]="specialityForm!">
            <div class="form-row">
                <label for="name">Szakrendelés neve <span class="required">*</span></label>
                <div class="form-input">
                    <input formControlName="name" id="name" type="text" required (blur)="onNameBlur()" />
                </div>
            </div>
            <div class="form-row">
                <label for="jobTitle">Szakrendelés munkaköre <span class="required">*</span></label>
                <div class="form-input">
                    <input formControlName="jobTitle" id="jobTitle" type="text" required />
                </div>
            </div>
            <div class="form-row">
                <label for="routerLink">{{ 'specialityForm.label.routerLink' | translate }} <span
                        class="required">*</span></label>
                <div class="form-input">
                    <input formControlName="routerLink" id="routerLink" type="text"
                        [placeholder]="'specialityForm.placeholder.routerLinkExample' | translate"
                        (input)="onSlugInput()" />
                    @if (shouldShowError('routerLink')) {
                    <span class="error">{{ 'specialityForm.error.slugInvalid' | translate }}</span>
                    }
                </div>
            </div>
        </form>

        <div class="form-row">
            <label>Kép (.jpg vagy .png)</label>
            <div class="form-input file-row">
                <button type="button" class="btn btn-file" onclick="document.getElementById('fileCover').click()">
                    Kép kiválasztása
                </button>
                @if (updateCoverFile) {
                <span>{{ fileCover?.name }}</span>
                } @else {
                <a href="{{ speciality.imageUrl }}" target="_blank">Jelenlegi borítókép</a>
                }
                <mat-icon class="delete-icon" (click)="clearSelectedCoverFile()">delete_forever</mat-icon>
                <input #fileCoverInput id="fileCover" type="file" hidden (change)="onChange($event)" />
            </div>
        </div>

        <div class="form-row full-width">
            <label>Szakrendelés leírása</label>
            <pf-fileexplorer />
            <div class="form-input">
                <app-tinymcehtmleditor id="html" ngDefaultControl [html]="speciality.description!"
                    [htmlForm]="htmlForm" />
            </div>
        </div>

        <div class="form-row">
            <label>Szakrendelés típusa</label>
            <div class="form-input">
                <div class="add-row">
                    <mat-icon class="add-icon" routerLink="/addspecialitytype">add_circle</mat-icon>
                </div>
                <div class="radio-wrap">
                    <mat-radio-group [(ngModel)]="specialityTypeName">
                        @for (specialityType of specialityTypeList; track specialityType) {
                        <mat-radio-button [value]="specialityType.name">
                            <span routerLink="/updatespecialitytype/{{ specialityType.id }}" class="clickable">
                                {{ specialityType.name }}
                            </span>
                        </mat-radio-button>
                        }
                    </mat-radio-group>
                </div>
            </div>
        </div>
    </div>

    <div class="form-section">
        <h4 class="section-title">{{ speciality.name }} - orvosok</h4>
        <div class="form-row">
            <div class="form-input checkbox-wrap">
                @for (doctorSpeciality of speciality.doctorSpecialityList; track doctorSpeciality) {
                <div class="job-title-item">
                    <input type="text" disabled [placeholder]="doctorSpeciality.doctor?.name" />
                    <mat-icon class="delete-icon"
                        (click)="openDoctorSpecialityDialog(doctorSpeciality)">delete_forever</mat-icon>
                </div>
                }
            </div>
        </div>

        <h4 class="section-title">Orvos hozzáadása szakrendeléshez (nem kötelező)</h4>
        <mat-icon class="add-icon" routerLink="/adddoctor">add_circle</mat-icon>
        <div class="form-row">
            <div class="form-input checkbox-wrap">
                @for (doctor of doctorsWithChecked; track doctor) {
                <section>
                    <mat-checkbox (click)="changeDoctor(doctor)">
                        <span class="small-text">{{ doctor.doctor?.name }}</span>
                    </mat-checkbox>
                </section>
                }
            </div>
        </div>
    </div>

    <div class="form-section">
        <h4 class="section-title">TÉTEL HOZZÁADÁSA (nem kötelező)</h4>
        <mat-icon class="add-icon" (click)="openAddExaminationDialog()">add_circle</mat-icon>

        <h4 class="section-title">Jelenlegi tételek</h4>
        @for (examination of speciality.examinationList; track examination; let i = $index) {
        <div class="examination-row" [ngStyle]="i % 2 === 0 ? { background: 'white' } : { background: '#efeff5' }">
            <div class="form-row no-border">
                <label>Tétel neve</label>
                <div class="form-input"><span>{{ examination.name }}</span></div>
            </div>
            @if (examination.price !== null) {
            <div class="form-row no-border">
                <label>Tétel ára:</label>
                <div class="form-input"><span>{{ examination.price | currency: 'Ft' : 'symbol' : '1.0-0' }}</span></div>
                <mat-icon class="delete-icon"
                    (click)="removeExaminationFromDb(examination.id!)">delete_forever</mat-icon>
            </div>
            }
            @if (examination.minPrice !== null) {
            <div class="form-row no-border">
                <label>Minimum ár:</label>
                <div class="form-input"><span>{{ examination.minPrice | currency: 'Ft' : 'symbol' : '1.0-0' }}</span>
                </div>
            </div>
            }
            @if (examination.maxPrice !== null) {
            <div class="form-row no-border">
                <label>Maximum ár:</label>
                <div class="form-input"><span>{{ examination.maxPrice | currency: 'Ft' : 'symbol' : '1.0-0' }}</span>
                </div>
                <mat-icon class="delete-icon"
                    (click)="removeExaminationFromDb(examination.id!)">delete_forever</mat-icon>
            </div>
            }
        </div>
        }

        @if (examinationList?.length! > 0) {
        <h4 class="section-title">Hozzáadandó tételek</h4>
        }
        @for (examination of examinationList; track examination; let i = $index) {
        <div class="examination-row" [ngStyle]="i % 2 === 0 ? { background: 'white' } : { background: '#efeff5' }">
            <div class="form-row no-border">
                <label>Tétel neve</label>
                <div class="form-input"><span>{{ examination.name }}</span></div>
            </div>
            @if (examination.price !== null) {
            <div class="form-row no-border">
                <label>Tétel ára:</label>
                <div class="form-input"><span>{{ examination.price | currency: 'Ft' : 'symbol' : '1.0-0' }}</span></div>
                <mat-icon class="delete-icon" (click)="removeExamination(i)">delete_forever</mat-icon>
            </div>
            }
            @if (examination.minPrice !== null) {
            <div class="form-row no-border">
                <label>Minimum ár:</label>
                <div class="form-input"><span>{{ examination.minPrice | currency: 'Ft' : 'symbol' : '1.0-0' }}</span>
                </div>
            </div>
            }
            @if (examination.maxPrice !== null) {
            <div class="form-row no-border">
                <label>Maximum ár:</label>
                <div class="form-input"><span>{{ examination.maxPrice | currency: 'Ft' : 'symbol' : '1.0-0' }}</span>
                </div>
                <mat-icon class="delete-icon" (click)="removeExamination(i)">delete_forever</mat-icon>
            </div>
            }
        </div>
        }

        <h4 class="section-title">SEO</h4>
        <pf-meta [isUpdate]="true" [urlPrefix]="specialityUrlPrefix" />
    </div>

    <div class="submit-row">
        <button class="btn btn-submit" [disabled]="!isFormValid" (click)="handleUpdateSpeciality()">
            SZAKRENDELÉS MENTÉSE
        </button>
    </div>
</div>